<div class="unauthorized-page">
  <div class="unauthorized-container">
    <div class="unauthorized-content">
      <div class="error-image">
        <svg xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240" fill="none">
          <!-- Background circle with gradient -->
          <defs>
            <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#DBEAFE;stop-opacity:0.6" />
              <stop offset="100%" style="stop-color:#BFDBFE;stop-opacity:0.3" />
            </linearGradient>
            <linearGradient id="lockGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#2563EB;stop-opacity:0.8" />
              <stop offset="100%" style="stop-color:#1E3A8A;stop-opacity:0.9" />
            </linearGradient>
          </defs>
          
          <circle cx="120" cy="120" r="110" fill="url(#bgGradient)"/>
          
          <!-- Lock icon -->
          <g transform="translate(120, 100)">
            <!-- Lock shackle -->
            <path d="M -25 -25 Q -25 -50 -12 -50 L 12 -50 Q 25 -50 25 -25" 
                  stroke="#2563EB" 
                  stroke-width="10" 
                  stroke-linecap="round" 
                  fill="none"
                  opacity="0.8"/>
            
            <!-- Lock body -->
            <rect x="-35" y="-25" width="70" height="55" rx="10" fill="url(#lockGradient)"/>
            <rect x="-30" y="-20" width="60" height="45" rx="8" fill="#2563EB" opacity="0.3"/>
            
            <!-- Keyhole -->
            <circle cx="0" cy="8" r="10" fill="#DBEAFE" opacity="0.9"/>
            <rect x="-4" y="8" width="8" height="18" rx="3" fill="#DBEAFE" opacity="0.9"/>
          </g>
          
          <!-- Shield with X (prohibition) -->
          <g transform="translate(120, 180)">
            <path d="M -30 -20 L 0 -35 L 30 -20 L 30 15 Q 30 25 20 30 L 0 35 L -20 30 Q -30 25 -30 15 Z" 
                  fill="#FF4444" 
                  opacity="0.95"/>
            <path d="M -30 -20 L 0 -35 L 30 -20 L 30 15 Q 30 25 20 30 L 0 35 L -20 30 Q -30 25 -30 15 Z" 
                  stroke="#CC0000" 
                  stroke-width="2" 
                  fill="none"/>
            <line x1="-18" y1="-8" x2="18" y2="22" 
                  stroke="white" 
                  stroke-width="5" 
                  stroke-linecap="round"/>
            <line x1="18" y1="-8" x2="-18" y2="22" 
                  stroke="white" 
                  stroke-width="5" 
                  stroke-linecap="round"/>
          </g>
        </svg>
      </div>

      <div class="error-content">
        <h1 class="error-code">401</h1>
        <h2 class="error-title">{{ 'unauthorized.title' | translate }}</h2>
        <p class="error-message">{{ 'unauthorized.message' | translate }}</p>
        <p class="error-instruction">{{ 'unauthorized.instruction' | translate }}</p>
        
        <div class="error-actions">
          <app-button 
            kind="ghost"
            (clicked)="goToLogin()">
            {{ 'unauthorized.backToLogin' | translate }}
          </app-button>
        </div>
      </div>
    </div>
  </div>
</div>
